import type { InventoryDispatch } from './types'

const STORAGE_KEY = 'erp.inventory.dispatches.v1'

function safeParse(json: string | null): InventoryDispatch[] {
  if (!json) return []
  try {
    const parsed = JSON.parse(json)
    if (!Array.isArray(parsed)) return []
    return parsed as InventoryDispatch[]
  } catch {
    return []
  }
}

export function listDispatches(): InventoryDispatch[] {
  return safeParse(window.localStorage.getItem(STORAGE_KEY))
}

export function getDispatch(id: string): InventoryDispatch | undefined {
  return listDispatches().find((d) => d.id === id)
}

export function upsertDispatch(dispatch: InventoryDispatch): void {
  const all = listDispatches()
  const idx = all.findIndex((d) => d.id === dispatch.id)
  const next = idx >= 0 ? all.map((d, i) => (i === idx ? dispatch : d)) : [dispatch, ...all]
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
}

